<dw-ui-dialog-box
  [title]="'Doc::GenerateSupplierOrders'"
  [displayFooter]="currentStep == PreparationStep.Generation"
  (cancelFn)="onCancel()"
  (closeFn)="onCancel()"
  (saveFn)="generateSupplierOrders()"
  [saveLabel]="'Doc::Generate' | abpLocalization"
>
  <div ngbAccordion class="my-3" [closeOthers]="true">
    <div ngbAccordionItem [collapsed]="currentStep != PreparationStep.Selection" [disabled]="true">
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton class="hide-button d-flex justify-content-between">
          <span>{{ 'Doc::GenerateSupplierOrders:SelectionStepTitle' | abpLocalization }}</span>
        </button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <form [formGroup]="form" (ngSubmit)="prepareSupplierOrders()">
            <div class="row row-cols-3">
              <div class="col">
                <label for="daybookId" class="form-label text-primary" dwInputRequired>
                  {{ 'Doc::SupplierOrder:Daybook' | abpLocalization }}
                </label>
                <ng-select
                  class="form-control"
                  id="daybookId"
                  formControlName="daybookId"
                  bindLabel="code"
                  bindValue="id"
                  [items]="daybooks()"
                >
                </ng-select>
              </div>
              <div class="col">
                <label for="grouping" class="form-label text-primary" dwInputRequired>
                  {{ 'Doc::SupplierOrder:Grouping' | abpLocalization }}
                </label>
                <ng-select
                  class="form-control"
                  id="grouping"
                  formControlName="grouping"
                  bindLabel="name.current"
                  bindValue="id"
                  [items]="docEnumerationTypeStore.supplierOrderGrouping()"
                  [loading]="docEnumerationTypeStore.loading()"
                  DwEnumSelect
                >
                </ng-select>
              </div>
              <div class="col">
                <label for="statusId" class="form-label text-primary" dwInputRequired>
                  {{ 'Doc::SupplierOrderGeneration:Status' | abpLocalization }}
                </label>
                <ng-select
                  class="form-control"
                  id="statusId"
                  formControlName="statusId"
                  bindLabel="name.current"
                  bindValue="id"
                  [items]="
                    docEnumerationTypeStore.supplierOrderStatus()
                      | filterBy: filterSupplierOrderStatus
                  "
                  [loading]="docEnumerationTypeStore.loading()"
                  DwEnumSelect
                >
                </ng-select>
              </div>
            </div>

            <div class="mt-3 d-flex justify-content-end">
              <button class="btn btn-primary" type="submit">
                {{ 'Doc::SupplierOrderGeneration:Ready' | abpLocalization }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div ngbAccordionItem [collapsed]="currentStep != PreparationStep.Generation" [disabled]="true">
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton class="hide-button d-flex justify-content-between">
          <span>{{ 'Doc::GenerateSupplierOrders:ReadyStepTitle' | abpLocalization }}</span>
        </button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <document-supplier-order-draft-grid
            [supplierOrderDrafts]="supplierOrderDrafts()"
          ></document-supplier-order-draft-grid>
        </div>
      </div>
    </div>
  </div>
</dw-ui-dialog-box>
